import i18n from "i18next";
import axios from "axios";

export const APPNAME = "Tech n Ctrl"
export const FOUNDER = "PIOU Hassan"

export const START_AT = 2024

export const TECH_MAIL = "info@technctrl.com"

export  const getData = async () =>{
   return await axios.get('/database.json')
        .then(response => {
          return response.data;
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
}

export const ActiveMenu = (path) =>{
    if (window.location.pathname === path) return "active"
}

export const CustomChangeLanguage = lang => {
    i18n.changeLanguage(lang)
    localStorage.setItem("I18N_LANGUAGE", lang)
    return lang
}

const  padTo2Digits = (num) => {
    return num.toString().padStart(2, '0');
}

export const  format_date = (date)  => {

    const dat = new Date(date)
    return [
        padTo2Digits(dat.getDate()),
        padTo2Digits(dat.getMonth() + 1),
        dat.getFullYear(),
    ].join('/');
}
